import React from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logoetb.png'
import image2 from './img/etbResponsive.png'

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = "etb";
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });



    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value,
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = "La contraseña no es correcta o el usuario no está registrado en nuestro sistema.";

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="etb-login-container" ref={this.ref}>
          <img
            className="logoetb"
            src={logo}
            alt="etb"
          />
          <h1>{translate("loginInfo")}</h1>
          <Form onSubmit={(event) => this.onSubmit(event)}>
            <div className="form-group mt-5">
              <label>{translate("PlaceholderUserName")}</label>
              <input
                disabled={this.state.onLogin}
                type="user"
                className="form-control input-user-etb"
                placeholder={"Usuario"}
                required={true}
                ref={(ref) => {
                  this.usernameInput = ref;
                }}
                tabIndex={1}
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
              />
            </div>
            <div className="form-group mt-5">
              <label>{translate("PlaceholderPassword")}</label>
              <input
                type="password"
                className="form-control input-pass-etb"
                placeholder={"Contraseña"}
                required={true}
                disabled={this.state.onLogin}
                ref={(ref) => {
                  this.passwordInput = ref;
                }}
                tabIndex={1}
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
            </div>
            {!this.state.onLogin ? (
              <button type="submit" className="btn btn-etb btn-lg btn-block" disabled={!this.props.turnstileSuccess}>
                {translate('ButtonEnter')}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={this.state.error.open}
                toggle={() => this.setState({ error: { open: false } })}
              >
                {this.state.error.message}
              </Alert>
            </div>
            <div className="etb-links">
              <p>
                <a
                  href="https://mietb.etb.com/recover-password/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="supportA"
                >
                  {translate("passwordRecovery")}
                </a>
              </p>
              {
                checkDeviceIOS() ? '' : <p>
                  <a
                    href="https://mietb.etb.com/login/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="supportA"
                  >
                    {translate("signUp")}
                  </a>
                </p>
              }
              <img className="etbResonsive" alt="etbLogin" src={image2} />
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
